<div class="stepper-wrapper">
  <p-stepper [value]="stepPanel.PanelOne" class="basis-[50rem]">
    <p-step-list>
      <p-step [value]="stepPanel.PanelOne" [disabled]="true">Modelos de Facturación</p-step>
      <p-step [value]="stepPanel.PanelTwo" [disabled]="true">Conceptos a copiar</p-step>
    </p-step-list>
    <p-step-panels>
      <p-step-panel [value]="stepPanel.PanelOne">
        <ng-template #content let-activateCallback="activateCallback">
          <div class="panel-content">
            @if (loading) {
            <div class="p-4">
              <p-skeleton styleClass="custom-skeleton-header"></p-skeleton>
              <p-skeleton styleClass="custom-skeleton-body"></p-skeleton>
            </div>
            } @else {
            <app-custom-table [showRecover]="true" [radioButton]="true" [showCheckbox]="true" [isMultipleSelect]="false"
              [data]="dataInvoicingModel" [headers]="headerInvoicingModel" [previousFilters]="filtersInvoicingModel"
              (onRecoverData)="getInvoicingModelsForSelectionAsync()" (selectionChange)="selectionChange($event)"
              (onPageChange)="onPageChange($event)" (onFilterChange)="onFilterChange($event)">
            </app-custom-table>
            }
          </div>
          <div class="d-flex justify-content-end">
            <app-custom-button [width]="'7'" [severity]="'contrast'" [label]="'Siguiente'" [icon]="'pi pi-arrow-right'"
              (onClick)="goToStep(stepPanel.PanelTwo, activateCallback)">
            </app-custom-button>
          </div>
        </ng-template>
      </p-step-panel>
      <p-step-panel [value]="stepPanel.PanelTwo">
        <ng-template #content let-activateCallback="activateCallback">
          @if(selectedInvoicingModel){
          <div class="selected-model-header mb-3">
            <h5 calss="basis-[50rem]">
              Modelo seleccionado:
              <span class="fw-bold">
                {{selectedInvoicingModel.consecutive}} -
                {{selectedInvoicingModel.description}}
              </span>
            </h5>
          </div>
          }
          <div class="panel-content">
            <app-custom-table [showRecover]="true" [showCheckbox]="true" [isMultipleSelect]="true"
              [data]="dataInvoicingModelDetail" [headers]="headerInvoicingModelDetail"
              [previousFilters]="filtersInvoicingModelDetail"
              (onRecoverData)="getInvoicingModelDetailForSelectionAsync()" (onPageChange)="onPageChange($event)"
              (onFilterChange)="onFilterChange($event)">
            </app-custom-table>
          </div>
          <div class="d-flex pt-6 justify-start">
            <app-custom-button [width]="'7'" [label]="'Regresar'" [severity]="'contrast'" [icon]="'pi pi-arrow-left'"
              (onClick)="goToStep(stepPanel.PanelOne, activateCallback)">
            </app-custom-button>
          </div>
        </ng-template>
      </p-step-panel>
    </p-step-panels>
  </p-stepper>
</div>